import styled from 'styled-components';
import theme from 'common/theme'

export const InputGroupContainer = styled.div`
  padding: .3em 0;

  &.has-error,
  &.is-required {
    border-color: red;
  }

  label {
    margin-bottom: .5em;
    color: ${theme.colors.label};
    font-weight: 500;
    font-size: .9em;
  }

  .input-group-message {
    margin-top: .5em;
  }
  input {
    background-color: ${theme.colors.gray200};
    border: none;
    outline: solid 1px ${theme.colors.gray300};
    border-radius: 4px;
    padding: .5em;
    &:focus {
      outline: solid 1px ${theme.colors.jbtBlue};
    }
    
    &:not(:focus-within) {
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: inner-spin-button;
      appearance: inner-spin-button;
      opacity: .5;
    }

    &::-moz-inner-spin-button,
    &::-moz-outer-spin-button {
      -moz-appearance: inner-spin-button;
      appearance: inner-spin-button;
      opacity: .5;
    }
}
  }

  &:focus-within {
    border-color: blue;
  }
    
  .red-star {
    color: red;
    font-weight: bold;
  }
`